<style lang="scss" scoped>
  .dalink-public-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding-top: 24px;

    .content-wrapper {
      width: 100%;
      max-width: 524px;
      padding: 0 12px;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .platform-link-wrapper {
      text-align: center;

      .platform-link {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        font-family: Inter, sans-serif;
        text-decoration: none;
        border-radius: 8px;
        background-color: rgba(0, 0, 0, 0.30);
        padding: 6px 10px;

        .platform-link-text {
          color: white;
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
        }

        .platform-link-icon {
          font-size: 16px;
          color: rgba(#F1F1F1, .6);
        }
      }
    }

    .dalink-page-footer {
      width: 100%;
      margin-top: auto;
    }

    .loader-screen {
      @include position-all(fixed, 0);
      z-index: 100;
      background-color: #1f1f1f;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .icon {
        position: absolute;
        font-size: 50px;
      }

      .loader {
        position: absolute;
        --main-color: #F59C07;
        --additional-color: #F57507;
      }
    }

    .fade-in-out {
      &-enter {
        opacity: 1;
      }

      &-leave {
        left: 0;
        top: 0;
        position: absolute;
      }

      &-leave-to {
        left: 0;
        top: 0;
        opacity: 0;
        position: absolute;
      }

      &-enter-active, &-leave-active {
        transition: opacity 300ms;
      }
    }
  }
</style>

<template>
  <div class="dalink-public-page">
    <transition name="fade-in-out">
      <div v-if="!ready" class="loader-screen">
        <loader size="xl"/>
        <icon name="social-dalink" system gradient/>
      </div>
    </transition>
    <template v-if="ready">
      <div class="content-wrapper">
        <dalink-page-content
          :data="userData"
          :widgets="widgetsOrderedList"
          :settings="pageSettings"
          :design="design"/>
      </div>
      <div class="platform-link-wrapper">
        <a target="_blank" href="/" class="platform-link">
          <div class="platform-link-text">Сделано на DALink</div>
          <icon name="dalink" class="platform-link-icon"/>
        </a>
      </div>
      <dalink-page-footer/>
    </template>
  </div>
</template>

<script setup>

import usePromise from '@composables/use-promise'
import { computed, onMounted, watch, ref } from 'vue'
import { useDalinkPublicStore } from '@store/dalinkPublic'
import { storeToRefs } from 'pinia'
import DalinkPageContent from '@components/Dalink/DalinkPageContent'
import { defaultScheme } from '@src/config/dalink/presets'
import DalinkPageFooter from '@components/Dalink/DalinkPageFooter'
import { useRoute } from 'vue-router/composables'

const props = defineProps({
  slug: {
    type: String,
    required: true,
  },
})

const dalinkPublicStore = useDalinkPublicStore()
const { setDonationsStatus, fetchCurrencies } = dalinkPublicStore

const { exec: fetchPageData } = usePromise(dalinkPublicStore.fetchPageData)

const {
  userData,
  pageSettings,
  widgetsOrderedList,
  pageDesign,
} = storeToRefs(dalinkPublicStore)

const design = computed(() => _.merge({}, defaultScheme, pageDesign.value))

const route = useRoute()

watch(() => route.query.donation_status, newDonationsStatus => {
  setDonationsStatus(newDonationsStatus)
}, { immediate: true })

const ready = ref(false)

onMounted(async () => {
  await Promise.all([
    fetchCurrencies(),
    fetchPageData(props.slug),
  ])

  ready.value = true
})

</script>
